import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Login from "./Login";
import Layout from "./Layout";
// import routes from "../constants/routes";
import Posts from "./Posts";
import Users from "./Users";
import Nodes from "./Nodes";
import Withdraw from "./Withdraw";

const queryClient = new QueryClient();

export default function App(): JSX.Element {
  const routes = [
    {
      path: "/",
      name: "Posts",
      title: "Posts Management",
      component: <Posts />,
    },
    {
      path: "/users",
      name: "Users",
      title: "Users Management",
      component: <Users />,
    },
    {
      path: "/nodes",
      name: "Nodes",
      title: "Nodes Management",
      component: <Nodes />,
    },
    {
      path: "/withdraw",
      name: "Withdraw",
      title: "Withdraw Review",
      component: <Withdraw />,
    },
  ];

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path={routes.map((item) => item.path)}>
            <Layout>
              <Switch>
                {routes.map((item, index) => (
                  <Route key={index} exact path={item.path}>
                    {item.component}
                  </Route>
                ))}
              </Switch>
            </Layout>
          </Route>
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
